import { render, staticRenderFns } from "./Genealogy.vue?vue&type=template&id=20e6eaa0&scoped=true"
import script from "./Genealogy.vue?vue&type=script&lang=js"
export * from "./Genealogy.vue?vue&type=script&lang=js"
import style0 from "./Genealogy.vue?vue&type=style&index=0&id=20e6eaa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e6eaa0",
  null
  
)

export default component.exports